import { required } from '../../../helpers'
import RuleDepends from './RuleDepends'

export default class RequiredWith extends RuleDepends {
  get ruleName () {
    return 'requiredWith'
  }

  passes () {
    return required(this.value) && required(this.data[this.dataAttribute])
  }
}
